import { render, staticRenderFns } from "./VehicleSvg.vue?vue&type=template&id=5389e068"
import script from "./VehicleSvg.vue?vue&type=script&lang=js"
export * from "./VehicleSvg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports